import { useEffect, useState } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { toastApiRef } from '@backstage/frontend-plugin-api';
import { useSignal } from '@backstage/plugin-signals-react';
import { NotificationSignal } from '@backstage/plugin-notifications-common';
import {
  notificationsApiRef,
  useNotificationsApi,
} from '@backstage/plugin-notifications';

export const useNotifications = () => {
  const { loading, error, value, retry } = useNotificationsApi(api =>
    api.getStatus(),
  );
  const notificationsApi = useApi(notificationsApiRef);
  const toastApi = useApi(toastApiRef);
  const [unreadCount, setUnreadCount] = useState(0);
  const { lastSignal } = useSignal<NotificationSignal>('notifications');
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    if (refresh) {
      retry();
      setRefresh(false);
    }
  }, [refresh, retry]);

  useEffect(() => {
    const handleNotificationSignal = (signal: NotificationSignal) => {
      if (signal.action !== 'new_notification') {
        return;
      }
      notificationsApi
        .getNotification(signal.notification_id)
        .then(notification => {
          if (!notification) {
            return;
          }
        })
        .catch(() => {
          toastApi.post({
            title: 'Failed to fetch notification',
            status: 'danger',
          });
        });
    };

    if (lastSignal?.action) {
      handleNotificationSignal(lastSignal);
      setRefresh(true);
    }
  }, [lastSignal, notificationsApi, toastApi]);

  useEffect(() => {
    if (!loading && !error && value) {
      setUnreadCount(value.unread);
    }
  }, [loading, error, value]);

  const count = !error && !!unreadCount ? unreadCount : undefined;

  return { count, loading, error };
};
